import { createWebHistory, createRouter } from 'vue-router';
import Home from '@/pages/Home.vue';
import Dashboard1 from '@/pages/Dashboard1.vue';
import Dashboard2 from '@/pages/Dashboard2.vue';
import Dashboard3 from '@/pages/Dashboard3.vue';
import Dashboard4 from '@/pages/Dashboard4.vue';
import Dashboard5 from '@/pages/Dashboard5.vue';
import Dashboard6 from '@/pages/Dashboard6.vue';
import Dashboard7 from '@/pages/Dashboard7.vue';
import Login from '@/pages/Login.vue';
import Mobile from '@/mobile/Mobile.vue';
import MobileHome from '@/mobile/Home.vue';
import MobileLogin from '@/mobile/Login.vue';
import Dashboard2Mobile from '@/mobile/Dashboard2.vue';
import Dashboard1Mobile from '@/mobile/Dashboard1.vue';
import Dashboard7Mobile from '@/mobile/Dashboard7.vue';
import Dashboard3Mobile from '@/mobile/Dashboard3.vue';
import Dashboard4Mobile from '@/mobile/Dashboard4.vue';
import Dashboard5Mobile from '@/mobile/Dashboard5.vue';
import Dashboard6Mobile from '@/mobile/Dashboard6.vue';

const moment = require('moment');

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
  },
  {
    path: '/dashboard1',
    name: 'Dashboard1',
    component: Dashboard1,
  },
  {
    path: '/dashboard2',
    name: 'Dashboard2',
    component: Dashboard2,
  },
  {
    path: '/dashboard3',
    name: 'Dashboard3',
    component: Dashboard3,
  },
  {
    path: '/dashboard4',
    name: 'Dashboard4',
    component: Dashboard4,
  },
  {
    path: '/dashboard5',
    name: 'Dashboard5',
    component: Dashboard5,
  },
  {
    path: '/dashboard6',
    name: 'Dashboard6',
    component: Dashboard6,
  },
  {
    path: '/dashboard7',
    name: 'Dashboard7',
    component: Dashboard7,
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
  },
  {
    path: '/mobile',
    component: Mobile,
    children: [
      { path: '', name: 'HomeMobile', component: MobileHome },
      { path: 'dashboard2', name: 'Dashboard2Mobile', component: Dashboard2Mobile },
      { path: 'dashboard1', name: 'Dashboard1Mobile', component: Dashboard1Mobile },
      { path: 'dashboard7', name: 'Dashboard7Mobile', component: Dashboard7Mobile },
      { path: 'dashboard3', name: 'Dashboard3Mobile', component: Dashboard3Mobile },
      { path: 'dashboard4', name: 'Dashboard4Mobile', component: Dashboard4Mobile },
      { path: 'dashboard5', name: 'Dashboard5Mobile', component: Dashboard5Mobile },
      { path: 'dashboard6', name: 'Dashboard6Mobile', component: Dashboard6Mobile },
      { path: 'login', name: 'LoginMobile', component: MobileLogin },
      { path: 'home', redirect: '' },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  // Treat both desktop and mobile login routes as public
  const publicPages = ['/login', '/mobile/login'];
  const authRequired = !publicPages.includes(to.path);

  const accessToken = localStorage.getItem('accessToken');
  const storedExpirationTime = localStorage.getItem('expirationTime');
  const isTokenExpired =
    storedExpirationTime == null ||
    moment(storedExpirationTime).isBefore(moment());

  // Detect mobile viewport (guard for environments where window is undefined)
  const isMobile = typeof window !== 'undefined' && window.innerWidth <= 768;
  const loginRedirect = isMobile ? '/mobile/login' : '/login';

  // If a mobile user lands on the root route, send them to mobile home
  if (to.path === '/' && isMobile) {
    next('/mobile');
    return;
  }

  // If a mobile user lands on the desktop login route, send them to the mobile login
  if (to.path === '/login' && isMobile) {
    next('/mobile/login');
    return;
  }

  if (authRequired && (!accessToken || isTokenExpired)) {
    next(loginRedirect);
  } else {
    next();
  }
});

export default router;
